import { Component, OnInit, Input } from '@angular/core';
import { RotationItem } from '../../../sdk/models/RotationItem';

@Component({
  selector: 'app-schedule-view-screenlist-item',
  templateUrl: './schedule-view-screenlist-item.component.html',
  styleUrls: ['./schedule-view-screenlist-item.component.css']
})
export class ScheduleViewScreenlistItemComponent implements OnInit {

  @Input() ri: any;
  @Input() currentlyPlaying: RotationItem;
  @Input() nextPlay: RotationItem;
  @Input() preloadedScreen: RotationItem;
  @Input() hideInactive: boolean;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/schedule-view/schedule-view-screenlist-item/schedule-view-screenlist-item.component.ts